import { openDB } from 'idb';

const DB_NAME = 'VideoCacheDB';
const STORE_NAME = 'videos';
const DB_VERSION = 1;

// Apri IndexedDB (crea se non esiste)
async function getDB() {
  return openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    },
  });
}

// Prendi il video (Blob) da IndexedDB, o undefined se non c'è
export async function getVideoFromIndexedDB(key) {
  const db = await getDB();
  return db.get(STORE_NAME, key);
}

// Salva il video (Blob) in IndexedDB
export async function saveVideoToIndexedDB(key, blob) {
  const db = await getDB();
  await db.put(STORE_NAME, blob, key);
}

// Cancella video da IndexedDB (utile se vuoi aggiornare)
export async function clearVideoFromIndexedDB(key) {
  const db = await getDB();
  await db.delete(STORE_NAME, key);
}
